import { TaxRebateProps } from "./TaxRebate";

export const TaxRebateTestPageObject = (props: TaxRebateProps) => ({
    getType: () => "TaxRebate",

    getValue: () => props.value,

    setValue: (value: string) => props.onChange(value),

    getWarning: () => props.warning,

    getError: () => props.error,
});
